<template>
  <section class="section">
    <div class="container-lg">
      <!-- header -->
      <div class="section__preview !pt-0 w-full flex md:flex-row flex-col">
        <div class="flex-1">
          <!-- skeleton title and subtitle -->
          <template v-if="loading">
            <div class="skeleton-text skeleton-title mb-2"></div>
            <div class="skeleton-text skeleton-subtitle mb-4"></div>
          </template>
          <!-- real title and subtitle -->
          <template v-else>
            <h3 class="section__preview-title">{{ sliderTitle }}</h3>
            <h4 class="section__preview-text mb-4 md:mb-10">
              {{ sliderSubTitle }}
            </h4>
          </template>
        </div>
        <!-- skeleton link -->
        <template v-if="loading">
          <div class="skeleton-text skeleton-link"></div>
        </template>
        <!-- real link -->
        <template v-else>
          <a
              :href="sliderLink"
              :title="in18.page_see_all"
              class="link fw-500 self-start md:self-center mb-4 md:mb-10"
          >
            {{ in18.page_see_all }} »
          </a>
        </template>
      </div>

      <!-- skeleton slider while loading -->
      <div v-if="loading" class="my-swiper flex gap-4 overflow-hidden">
        <div
            v-for="n in placeholderCount"
            :key="n"
            class="skeleton-item rounded-lg"
        ></div>
      </div>

      <!-- настоящий слайдер -->
      <swiper
          v-else
          loop
          lazy
          :speed="1000"
          :modules="[Autoplay]"
          :autoplay="{ delay: 2500, disableOnInteraction: false, pauseOnMouseEnter: true }"
          :slides-per-view="5"
          :breakpoints="breakpoints"
          class="my-swiper"
          @swiper="onSwiper"
      >
        <swiper-slide
            v-for="product in items"
            :key="product.id"
        >
          <div class="slider-item pt-3" style="height:100%">
            <product-item :product="product"/>
          </div>
        </swiper-slide>
      </swiper>

      <div v-if="!loading" class="slider-arrows slider-arrows--center py-4">
        <button class="slider__arrows-prev" @click="swiperRef.slidePrev()">
          {{ in18.page_previous }}
        </button>
        <button class="slider__arrows-next" @click="swiperRef.slideNext()">
          {{ in18.page_next }}
        </button>
      </div>
    </div>
  </section>
</template>

<script setup lang="js">
import {ref, onMounted, onUnmounted, computed} from 'vue'
import {Swiper, SwiperSlide} from 'swiper/vue'
import {Autoplay} from 'swiper/modules'
import 'swiper/css'
import axios from 'axios'

const props = defineProps({
  type: String,
  in18: Object,
  data: Object
})

// состояние загрузки
const loading = ref(true)
// данные слайдера
const items = ref([])
const sliderTitle = ref('')
const sliderSubTitle = ref('')
const sliderLink = ref('')
const swiperRef = ref(null)

// брейкпоинты для Swiper
const breakpoints = {
  1200: {slidesPerView: 5},
  840:  {slidesPerView: 3},
  666:  {slidesPerView: 2},
  380:  {slidesPerView: 2},
  0:    {slidesPerView: 2}
}

// реактивная ширина окна
const windowWidth = ref(window.innerWidth)
const updateWidth = () => {
  windowWidth.value = window.innerWidth
}
onMounted(() => window.addEventListener('resize', updateWidth))
onUnmounted(() => window.removeEventListener('resize', updateWidth))

// динамическое число скелетонов под текущее slidesPerView
const placeholderCount = computed(() => {
  const points = Object.keys(breakpoints)
      .map(n => parseInt(n))
      .sort((a, b) => a - b)

  let count = breakpoints[points[0]].slidesPerView
  for (const minW of points) {
    if (windowWidth.value >= minW) {
      count = breakpoints[minW].slidesPerView
    }
  }
  return count
})

function onSwiper(sw) {
  swiperRef.value = sw
}

onMounted(async () => {
  const qs = props.data
      ? '?' + new URLSearchParams(props.data).toString()
      : ''
  const {data} = await axios.get(`/api/slider/${props.type}${qs}`)
  items.value = data.slider.products
  sliderTitle.value = data.slider.title
  sliderSubTitle.value = data.slider.sub_title
  sliderLink.value = data.slider.link
  loading.value = false
})
</script>